<template>
  <div class="nearbyCustomer" :isLoading="isLoading">
    <div class="searchArea">
      <el-form inline>
        <el-form-item>
          <el-select v-model="value1">
            <el-option
                v-for="item in options1"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          附近
          <el-select v-model="distance" placeholder="请选择" style="width: 100px">
            <el-option
                v-for="item in distanceList"
                :key="item.value"
                :label="item.label"
                :value="item.label">
            </el-option>
          </el-select>
          米的客户
        </el-form-item>

        <el-form-item style="position: relative;z-index: 2002">
          <el-input v-model.trim="address"
                    placeholder="请输入地址查找客户资源"
                    maxlength="100" clearable
                    @input="writeAddress"></el-input>
          <transition name="el-zoom-in-top">
            <div v-if="pois.length">
              <ul class="posiList" >
                <li v-for="(poi,index) in pois" :key="index" @click="poiclick(index,poi);" @mouseover="isclick=index">
                  <div :style="{'color':isclick==index?'#25A5F7':'#606266'}" style="font-weight: bold">{{ poi.name }}</div>
                  <div :style="{'color':isclick==index?'#25A5F7':'#606266'}" style="line-height: 20px">
                    {{ poi.pname + poi.cityname + poi.adname + poi.address }}
                  </div>
                </li>
              </ul>
              <div class="arrow"></div>
            </div>
          </transition>

        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="changePage(1)">搜索</el-button>
        </el-form-item>
      </el-form>
      <div class="el-icon-location-information" :title="tempPoi.pname+tempPoi.cityname+tempPoi.adname+tempPoi.address || ''">
        {{tempPoi.pname+tempPoi.cityname+tempPoi.adname+tempPoi.address || ''}}
      </div>
    </div>

    <div class="mapArea">
      <div class="mapList">
        <ul>
          <li v-for="item in resultList" :key="item.id" :class="{ 'active':item.id === tempId }" @mouseenter="changeIcon(item)">
            <div class="el-icon-location"></div>
            <div style="flex: 1;overflow: hidden">
              <div class="title" :title="item.customerName">{{ item.customerName }}</div>
              <div class="item">
                <div class="label">负责人：</div>
                <div class="value">{{ item.chargeName }}</div>
              </div>
              <div class="item">
                <div class="label">地址：</div>
                <div class="value" :title="item.province+item.city+item.district+item.address">
                  {{ item.province+item.city+item.district+item.address }}
                </div>
              </div>
              <div class="item">
                <div class="label">距离选择地址：</div>
                <div class="value">{{ item.distance }}m</div>
              </div>
              <div class="item">
                <div class="label">客户状态：</div>
                <div class="value">{{ item.followupStateName }}</div>
              </div>
            </div>
          </li>

          <div style="display: flex;flex: 1;justify-content: center" v-if="!resultList.length">
            <el-empty description="附近暂无客户"></el-empty>
          </div>

          <div class="pagination" v-show="dataCount">
            <el-pagination
                small
                background
                layout="prev, pager, next"
                :pager-count="5"
                :currentPage="currentPage"
                :page-size="pageSize"
                :total="dataCount"
                @current-change="changePage"
            >
            </el-pagination>
          </div>
        </ul>
      </div>

      <div 
        id="container" 
        v-loading="isLoading"
        element-loading-text="定位中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.5)"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      address: '',
      value1: '-1',
      distance: '200',
      options1: [
        {
          value: '-1',
          label: '全部'
        },
        {
          value: '0',
          label: '客户'
        },
        {
          value: '1',
          label: '公海'
        },
      ],
      distanceList: [
        {
          value: '选项1',
          label: '200'
        },
        {
          value: '选项2',
          label: '500'
        },
        {
          value: '选项3',
          label: '1000'
        },
        {
          value: '选项4',
          label: '2000'
        },
        {
          value: '选项5',
          label: '5000'
        },
        {
          value: '选项6',
          label: '10000'
        }
      ],
      // 地图实例
      map: '',
      // 预览位置列表
      pois: [],
      // 悬浮的index
      isclick: '',
      // maker标记
      endMarker: '',
      // 选择的中心点对象全部信息
      tempPoi: '',
      // 选择的中心点位置
      selectCenterLocation: '',
      // 圆形区域对象
      circle: '',
      resultList: [],
      nearMarkerList: [],
      tempId: '',

      currentPage: 1,
      pageSize: 20,
      dataCount: 0,
    }
  },
  mounted() {
    this.initMap();
  },
  methods: {
    initMap() {
      // this.isLoading = true;
      this.map = new AMap.Map('container', {
        resizeEnable: true,
        center: [116.397428, 39.90923],
        zoom: 18
      });
      //定位
      this.map.plugin('AMap.Geolocation', () => {
        var geolocation = new AMap.Geolocation({
          enableHighAccuracy: true,//是否使用高精度定位，默认:true
          timeout: 10000,          //超过10秒后停止定位，默认：5s
          buttonPosition: 'RB',    //定位按钮的停靠位置
          buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
          zoomToAccuracy: true,   //定位成功后是否自动调整地图视野到定位点
        });
        this.map.addControl(geolocation);
        geolocation.getCurrentPosition((status, result) => {
          if (status == 'complete') {
            console.log("定位成功"+result);
            // 定位成功，地图中心移动到定位点
            // this.isLoading = false;
            // this.map.setCenter(result.center);
          } else {
            console.log("定位失败,失败原因排查信息" + result.message)
            // // 定位失败的话就定位到城市
            // geolocation.getCityInfo((status, result) => {
            //   this.$message.warning("当前浏览器不支持精准定位，已为您定位到城市！")
            //   this.map.setZoom(14);
            //   console.log(result)
            //   // 定位成功，地图中心移动到定位点
            //   this.isLoading = false;
            //   this.map.setCenter(result.center);
            // })
          }
        });
      });
    },
    searchAddress() {
      if(this.tempPoi) {
        this.tempId = '';
        this.map.remove(this.circle);
        this.map.remove(this.nearMarkerList);
        this.circle = new AMap.Circle({
          center: this.selectCenterLocation,
          radius: this.distance, //半径
          borderWeight: 0,
          strokeColor: "#83c4fd",
          strokeWeight: 0,
          strokeOpacity: 0.2,
          fillOpacity: 0.4,
          strokeDasharray: [10, 10],
          // 线样式还支持 'dashed'
          fillColor: '#83c4fd',
          zIndex: 50,
        })
        this.circle.setMap(this.map)
        // 缩放地图到合适的视野级别
        this.map.setFitView([ this.circle ])
        let params = {
          mapLng: this.selectCenterLocation[0],
          mapLat: this.selectCenterLocation[1],
          range: this.distance,
          isShare: this.value1,
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
        }
        this.axios.get(`Crm/Customer/NearbyCustomerList`,{params}).then(res => {
          this.resultList = res.data;
          this.dataCount = res.dataCount;
          this.resultList.forEach(r => {
            let mark = new AMap.Marker({
              map: this.map,
              icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
              position: [r.mapLng, r.mapLat],
              id: r.id,
            });
            this.nearMarkerList.push(mark);
          })
        })
      } else {
        this.$message.warning(`请先输入并选择列表中的地址！`);
      }
    },
    changeIcon(item) {
      this.tempId = item.id;
      this.map.remove(this.nearMarkerList);
      let tempResultList = JSON.parse(JSON.stringify(this.resultList));
      //调整标记点位置，将目前选择的标记点高亮显示到同位置最前面
      tempResultList.forEach((w,index) => {
        if(this.tempId == w.id) {
          tempResultList.splice(index,1);
          tempResultList.push(w);
        }
      })
      tempResultList.forEach(r => {
        let mark = new AMap.Marker({
          map: this.map,
          icon: item.id === r.id?'//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png':'//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
          position: [r.mapLng, r.mapLat],
          id: r.id,
        });
        this.nearMarkerList.push(mark);
      })
      this.map.setCenter([item.mapLng, item.mapLat]);
    },
    writeAddress() {
      this.tempPoi = '';
      if( this.address ) {
        this.isclick = '';
        this.$jsonp(`//restapi.amap.com/v3/place/text?key=264e55a30128eb0ffa4ecef0c41374eb&keywords=${ this.address }`).then(res => {
          this.pois = res.pois;
        })
      }
    },
    poiclick(index,poi) {
      this.resultList = [];
      this.dataCount = 0;
      this.tempPoi = poi;
      this.selectCenterLocation = poi.location.split(',');
      this.address = poi.name;
      this.pois = [];
      // 移除上一个标记点
      this.map.clearMap();

      // 设置地图标记点
      this.endMarker = new AMap.Marker({
        position: this.selectCenterLocation,
        icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
      });
      // 设置地图标记点信息
      this.endMarker.setLabel({
        content: poi.name, //设置文本标注内容
        direction: 'top', //设置文本标注方位
        offset: new AMap.Pixel(0, -3), //设置文本标注偏移量
      });

      // 将创建的点标记添加到已有的地图实例：
      this.map.add(this.endMarker);
      this.map.setZoomAndCenter(18, this.selectCenterLocation); //同时设置地图层级与中心点
    },
    reset() {
      Object.assign(this.$data,this.$options.data());
      this.initMap();
    },
    changePage(e) {
      this.currentPage = e;
      this.searchAddress();
    },
  },
}
</script>

<style scoped lang="scss">
  ::v-deep .el-loading-text {
    color: #eaeaea; /* 字体颜色 */
  }
  
  ::v-deep .el-loading-spinner i {
    color: white; /* 加载圈颜色 */
    font-size: 20px;
  }
  
  .nearbyCustomer {
    display: flex;
    flex-direction: column;

    .searchArea {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      .el-form {
        .el-form-item {
          margin-bottom: 0;
        }
      }

      .posiList {
        position: absolute;
        background: white;
        z-index: 2002;
        border: 1px solid #DCDFE6;
        max-height: 500px;
        overflow-y: auto;
        margin-top: 10px;
        border-radius: 5px;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        padding-left: 8px;
        li {
          border-bottom: 1px solid #d0d0d0;
          cursor: pointer;
          padding: 5px;
        }
      }
      .arrow {
        position: absolute;
        width: 0;
        height: 0;
        border-color: transparent;
        border-bottom-color: #EBEEF5;
        border-style: solid;
        border-width: 5px;
        top: 33px;
        left: 35px;
        z-index: 2002;
        &::after {
          content: '';
          position: absolute;
          display: block;
          width: 0;
          height: 0;
          border-color: transparent;
          border-style: solid;
          top: -4px;
          margin-left: -5px;
          border-width: 5px;
          border-bottom-color: #FFFFFF;
        }
      }

      .el-icon-location-information {
        max-width: 500px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    .mapArea {
      display: flex;
      flex: 1;
      overflow: hidden;

      .mapList {
        position: relative;
        width: 300px;
        background: #F4F5F7;
        border-radius: 5px;
        overflow: hidden;
        margin-right: 10px;
        display: flex;
        flex-shrink: 0;

        ul {

          display: flex;
          flex-direction: column;
          padding: 10px 10px 36px 10px;
          overflow: auto;
          flex: 1;

          .pagination {
            padding: 3px 0;
            width: 90%;
            position: absolute;
            bottom: 0;
            background: #F4F5F7;
            .el-pagination {
              display: flex;
              justify-content: center;
            }
          }



          li {
            box-sizing: border-box;
            display: flex;
            width: 100%;
            border: 1px solid #DFE1E6;
            background: white;
            border-radius: 5px;
            padding: 10px;
            margin-bottom: 10px;
            cursor: pointer;
            transition: all .2s;

            .el-icon-location {
              color: red;
              font-weight: bold;
              padding-top: 2px;
              margin-right: 10px;
              font-size: 17px;
            }

            .title {
              color: #006eff;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .item {
              display: flex;
              .label {
                color: #999999;
                flex-shrink: 0;
              }
              .value {
                color: #333333;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }

          .active {
            background: #DEEBFF;
          }
        }
      }

      #container {
        width: 100%;
        height: 100%;

        ::v-deep {
          .amap-logo {
            display: none !important;
          }

          .amap-copyright {
            display: none !important;
          }

          .amap-icon {
            img {
              width: 25px;
              height: 34px;
            }
          }

          .amap-marker-label {
            background: #3D9CFC;
            color: white;
            border: 0;
            border-radius: 3px;
            padding: 7px 12px;
          }
        }
      }
    }
  }
</style>
